import * as moment from "moment";
import { useEffect, useState } from "react";
import { Card, Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { userSignal } from "../../../signal/userSignal";
import { DEV_SERVER } from "../../../constants/urls";
import axios from "axios";
import { useQueries, useQuery } from "react-query";
import { toast } from "react-toastify";
import { allUsersSignal } from "../../../signal/allUsersSignal";
import { useNavigate } from "react-router-dom";
import avatar1 from "../../../assets/images/avatars/01.png"
import DataTable from "react-data-table-component";
import { attendenceExcelGenerator } from "../../../utilities/excelGenerator";
import { organisationSignal } from "../../../signal/organisationSignal";

const customStyles = {
    cells: {
        style: {
            '&:first-child': {
                position: 'sticky',
                left: 0,
                zIndex: 1,
                backgroundColor: '#ffffff',
                borderRight: '1px solid #dee2e6',
            },
        },
    },
    headCells: {
        style: {
            '&:first-child': {
                position: 'sticky',
                left: 0,
                zIndex: 2,
                backgroundColor: '#ffffff',
                borderRight: '1px solid #dee2e6',
            },
        },
    },
};

export default function AttendenceSheet() {

    let today = new Date()
    let startOfMonthInMs = new Date(today.getFullYear(), today.getMonth(), 1);
    let yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
    if(startOfMonthInMs > yesterday){
        yesterday = startOfMonthInMs;
    }
    const [fromDate, setFromDate] = useState(moment(startOfMonthInMs).format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState(moment(yesterday).format("YYYY-MM-DD"));
    const [attendences, setAttendences] = useState([]);
    const [expenses, setExpenses] = useState([]);
    const [periodicExpenses, setPeriodicExpenses] = useState([]);
    const [attendenceData, setAttendenceData] = useState({});
    const [columns, setColumns] = useState([]);

    const navigate = useNavigate();


    const getAttendences = useQuery("employeeAttendence", async () => {
        let resp = await axios.get(`${DEV_SERVER}/auth/v2/attendence?startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 999)}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {

                setAttendences(data.data);
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    const expensesMutation = useQuery("expenses", async () => {
        let resp = await axios.get(`${DEV_SERVER}/expense/v2?startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 999)}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setExpenses(data.data);
                // userExcelGenerator({ expenses: data.data, leaves, trips })
            } else {
                toast.error(data.message);
            }
        },
    })

    const periodicExpensesMutation = useQuery("periodicExpenses", async () => {
        let resp = await axios.get(`${DEV_SERVER}/expense/v2/periodicExpenses?startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 999)}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setPeriodicExpenses(data.data);
            } else {
                toast.error(data.message);
            }
        },
    })

    const getData = async () => {
        getAttendences.refetch({ cancelRefetch: true });
        expensesMutation.refetch({ cancelRefetch: true });
        periodicExpensesMutation.refetch({ cancelRefetch: true });

    }

    useEffect(() => {
        if (!getAttendences.isFetching && !getAttendences.isLoading && !expensesMutation.isFetching && !expensesMutation.isLoading && !periodicExpensesMutation.isFetching && !periodicExpensesMutation.isLoading && (attendences.length || expenses.length || periodicExpenses.length)) {
            let data = {}
            let stateName = window.localStorage.getItem("state");
            attendences.map((attendence, index) => {
                let date = new Date(attendence.startTime).setHours(0, 0, 0, 0);
                if (!allUsersSignal.value[attendence?.userId]) {
                    return
                }

                let temp = data[attendence.userId] || {};

                if(!temp[date]){
                    temp[date] = index;
                }else{
                    let existingIndex = temp[date];
                    let existingAttendence = attendences[existingIndex];
                    let currentAttendence = attendences[index];

                    if(currentAttendence?.isPresent) {
                        temp[date] = index;
                    }else{
                        if(!existingAttendence?.isPresent && existingAttendence?.leaveId !== "000000000000000000000000"){
                        }else{
                            temp[date] = index;
                        }
                    }

                }
                data[attendence.userId] = temp;
            })

            Object.keys(data).map((userId) => {
                let temp = data[userId];
                let fullDay = 0;
                let halfDay = 0;
                let quarterDay = 0;
                let weekOffs = 0;
                let absents = 0;
                let leaves = 0;
                let holidays = 0;

                let details = {}

                

                Object.keys(temp).map((date) => {
                    let index = temp[date];
                    let attendence = attendences[index];

                    let selectedDate = moment(attendence.startTime).format("DD");
                    let status = ""

                    if (attendence?.isPresent) {
                        status = "P"
                    } else if (!attendence?.isPresent) {
                        if (attendence?.leaveId !== "000000000000000000000000") {
                            status = "L"
                        }
                    }

                    let timeDiff = (attendence.endTime - attendence.startTime) / 1000;
                    let hours = Math.floor(timeDiff / 3600);

                    if (status !== "") {

                        details[selectedDate] = status;
                        if (status === "P") {
                            if (hours >= 8) {
                                details[selectedDate] = "P"
                                fullDay += 1;
                            } else if (hours >= 4) {
                                details[selectedDate] = "P/2"
                                halfDay += 1;
                            } else {
                                details[selectedDate] = "P/4"
                                quarterDay += 1;
                            }
                        }
                    }
                })


                let start = moment(moment(Math.max(new Date(fromDate).getTime(), allUsersSignal?.value[userId]?.createdAt)).format("YYYY-MM-DD"));
                let end = moment(toDate);
                
                while (start <= end) {

                    let selectedDate = moment(start).format("DD");

                    if (!details[selectedDate]) {


                        let isThisSaturday = moment(start).day() === 6;
                        let isThisSunday = moment(start).day() === 0;
                        let thisDate = moment(start).format('DD/MM');
                        let isHoliday = false;
                        let isWeekOff = false;

                        if (isThisSaturday && !organisationSignal?.value?.isSaturdayWorking) {
                            isWeekOff = true;
                        }
                        else if (isThisSunday && !organisationSignal?.value?.isSundayWorking) {
                            isWeekOff = true;
                        }
                        else if (organisationSignal?.value?.holidays !== undefined && !isWeekOff) {
                            if (organisationSignal?.value?.holidays[thisDate]) {
                                isHoliday = true;
                            }
                        }


                        if (!isHoliday && !isWeekOff) {
                            details[selectedDate] = "A"
                        } else {
                            if(isWeekOff){
                                details[selectedDate] = "WO"
                            }else{
                                details[selectedDate] = "H"
                            }
                        }
                    }
                    let status = details[selectedDate]
                    if (status === "H") {
                        holidays += 1
                    }
                    else if (status === "A") {
                        absents += 1;
                    } else if (status === "L") {
                        leaves += 1;
                    }else if(status === "WO"){
                        weekOffs += 1;
                    }
                    start = moment(start).add(1, 'days');
                }

                details["fullDay"] = fullDay;
                details["halfDay"] = halfDay;
                details["quarterDay"] = quarterDay;
                details["weekOffs"] = weekOffs;
                details["absents"] = absents;
                details["leaves"] = leaves;
                details["holidays"] = holidays;

                data[userId] = details

            })

            Object.keys(allUsersSignal.value).map((userId) => {
                let temp = data[userId] || {};
                temp["userId"] = userId
                temp["expense"] = 0;
                data[userId] = temp;

                
            })

            expenses.map((expense) => {
                if (expense.status !== "rejected" && expense?.userId && expense?.userId?.length) {
                    let temp = data[expense?.userId[0].id] || {};
                    let initialAmount = temp["expense"] || 0;
                    temp["expense"] = initialAmount + expense.amount;
                    data[expense?.userId[0].id] = temp;
                }
            })

            periodicExpenses.map((expense) => {
                let temp = data[expense?.userId[0].id] || {};
                let initialAmount = temp["expense"] || 0;
                temp["expense"] = initialAmount + expense.amount;
                data[expense?.userId[0].id] = temp;
            })


            Object.keys(allUsersSignal.value).map((userId) => {
                if(stateName && stateName !== allUsersSignal.value[userId]?.state) {
                    delete data[userId];
                }
            })

            let columnsData = [
                {
                    name: "User",
                    width: "250px",
                    selector: (row) => {
                        if (row?.userId) {
                            return (
                                <div onClick={() => navigate(`/dashboard/trips/${row?.userId}`)} className="d-flex align-items-center" style={{ columnGap: "0.4rem" }}>
                                    <img
                                        style={{ width: "20px", height: "20px" }}
                                        src={(allUsersSignal.value[row?.userId]?.profileURL === "" || allUsersSignal.value[row?.userId]?.profileURL === undefined) ? avatar1 : allUsersSignal.value[row?.userId]?.profileURL}
                                        className="rounded-circle avatar-xs"
                                        alt="friend"
                                    />
                                    <OverlayTrigger placement="top" overlay={
                                        <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                                            {allUsersSignal.value[row?.userId]?.name}
                                        </Tooltip>}>
                                        <span style={{ width: "100%" }}>{allUsersSignal.value[row?.userId]?.name}</span>
                                    </OverlayTrigger>
                                </div>
                            )
                        }
                        return "-"
                    }
                },
            ]

            let currentDate = new Date(fromDate);
            while (currentDate <= new Date(toDate)) {
                let selectedDate = moment(currentDate).format("DD");
                columnsData.push({
                    name: selectedDate,
                    center: true,
                    selector: (row) => {
                        if (row[selectedDate]) {
                            return row[selectedDate]
                        }
                        return "-"
                    }
                })
                currentDate.setDate(currentDate.getDate() + 1);
            }

            columnsData.push({
                name: "P",
                center: true,
                selector: (row) => {
                    if (row.fullDay) {
                        return row.fullDay
                    }
                    return 0
                }
            })

            columnsData.push({
                name: "P/2",
                center: true,
                selector: (row) => {
                    if (row.halfDay) {
                        return row.halfDay
                    }
                    return 0
                }
            })

            columnsData.push({
                name: "P/4",
                center: true,
                selector: (row) => {
                    if (row.quarterDay) {
                        return row.quarterDay
                    }
                    return 0
                }
            })

            columnsData.push({
                name: "WO",
                center: true,
                selector: (row) => {
                    if (row.weekOffs) {
                        return row.weekOffs
                    }
                    return 0
                }
            })

            columnsData.push({
                name: "A",
                center: true,
                selector: (row) => {
                    if (row.absents) {
                        return row.absents
                    }
                    return 0
                }
            })

            columnsData.push({
                name: "L",
                center: true,
                selector: (row) => {
                    if (row.leaves) {
                        return row.leaves
                    }
                    return 0
                }
            })

            columnsData.push({
                name: "H",
                center: true,
                selector: (row) => {
                    if (row?.holidays) {
                        return row?.holidays;
                    }
                    return 0;
                }
            })



            columnsData.push({
                name: "Expense",
                center: true,
                selector: (row) => {
                    if (row.expense) {
                        return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }} id="tooltip-top">
                            {parseFloat(row.expense).toFixed(2)}
                        </Tooltip>}>
                            <span>{parseFloat(row.expense).toFixed(2)}</span>
                        </OverlayTrigger>
                    }
                    return 0.0
                }
            })

            columnsData.push({
                name: "Department",
                center: true,
                selector: (row) => {
                    if (allUsersSignal.value[row.userId]?.state) {
                        return (allUsersSignal.value[row.userId]?.state).toUpperCase()
                    }
                    return "-"
                }
            })

            columnsData.push({
                name: "Designation",
                center: true,
                selector: (row) => {
                    if (allUsersSignal.value[row.userId]?.designation) {
                        return allUsersSignal.value[row.userId]?.designation
                    }
                    return "-"
                }
            })
            setColumns(columnsData);
            setAttendenceData(data);

        }
    }, [attendences, expenses, periodicExpenses])




    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Attendence Sheet</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div style={{ display: "flex", alignItems: "flex-end", columnGap: "1rem", marginBottom: "1rem" }}>
                                        <div>
                                            <label htmlFor="fromDate">From Date</label>
                                            <input type="date" id="fromDate" className="form-control vanila-datepicker" names="start" placeholder="From Date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                                        </div>
                                        <div>
                                            <label htmlFor="toDate">To Date</label>
                                            <input type="date" id="toDate" className="form-control vanila-datepicker" names="start" placeholder="To Date" value={toDate} max={moment(yesterday).format("YYYY-MM-DD")} onChange={(e) => setToDate(e.target.value)} />
                                        </div>
                                        <button className="btn btn-primary" onClick={getData}>Generate Report</button>
                                    </div>

                                    <button className="btn btn-success" onClick={() => attendenceExcelGenerator(attendenceData, columns, allUsersSignal.value, `Attendence Sheet ${moment(fromDate).format("DD/MM/YY")} - ${moment(toDate).format("DD/MM/YY")}`)} disabled={getAttendences.isLoading || getAttendences?.isFetching || expensesMutation.isLoading || expensesMutation?.isFetching || periodicExpensesMutation.isLoading || periodicExpensesMutation?.isFetching}>
                                        <svg id="SvgjsSvg1001" width="20" height="20" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" xmlnsSvgjs="http://svgjs.com/svgjs"><defs id="SvgjsDefs1002"></defs><g id="SvgjsG1008"><svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 18765 21993" width="20" height="20"><path fill-rule="nonzero" d="M4317 0l9063 0c285,0 530,102 731,303l4351 4350c201,202 303,447 303,732l0 13155c0,910 -742,1652 -1653,1652l-11137 0c-53,0 -98,-28 -123,-75 -24,-46 -20,-99 10,-142l777 -1104c26,-38 66,-59 112,-59l10361 0c150,0 273,-123 273,-272l0 -12943 -2764 0c-801,0 -1454,-653 -1454,-1454l0 -2763 -8850 0c-150,0 -273,123 -273,272l0 10524c0,75 -62,137 -138,137l-1104 0c-76,0 -138,-62 -138,-137l0 -10524c0,-910 742,-1652 1653,-1652zm2039 17106l-1288 0c-159,0 -288,-129 -288,-288l0 -3424c0,-158 -129,-287 -288,-287l-2339 0c-159,0 -288,129 -288,287l0 3424c0,159 -129,288 -288,288l-1288 0c-110,0 -205,58 -255,155 -51,98 -44,209 20,299l3033 4311c56,79 139,122 235,122 97,0 180,-43 236,-122l3033 -4311c64,-90 71,-201 20,-299 -50,-97 -145,-155 -255,-155zm-394 -12701l3588 0c107,0 194,88 194,195l0 775c0,107 -87,194 -194,194l-3588 0c-107,0 -194,-87 -194,-194l0 -775c0,-107 87,-195 194,-195zm970 3727l0 2150 4056 0 0 -2150 -4056 0zm0 3314l0 2150 4056 0 0 -2150 -4056 0zm5220 -1164l2345 0 0 -2150 -2345 0 0 2150zm2345 1164l-2345 0 0 2150 2345 0 0 -2150zm1164 -3509l0 2539 0 775 0 2539 0 355 0 420c0,107 -87,194 -194,194l-9505 0c-107,0 -194,-87 -194,-194l0 -420 0 -355 0 -2539 0 -775 0 -2539 0 -355 0 -420c0,-107 87,-194 194,-194l9505 0c107,0 194,87 194,194l0 420 0 355z" fill="white" class="color000 svgShape"></path></svg></g></svg> Export
                                    </button>
                                </div>

                                {(!getAttendences.isLoading && !getAttendences?.isFetching && !expensesMutation.isLoading && !expensesMutation?.isFetching && !periodicExpensesMutation.isLoading && !periodicExpensesMutation?.isFetching && (attendences.length > 0 || expenses.length > 0 || periodicExpenses.length > 0)) && <DataTable
                                    columns={columns}
                                    data={Object.values(attendenceData)}
                                    customStyles={customStyles}
                                    pagination={true}
                                    paginationPerPage={600}
                                />}
                                {(getAttendences.isLoading || getAttendences?.isFetching || expensesMutation.isLoading || expensesMutation?.isFetching || periodicExpensesMutation.isLoading || periodicExpensesMutation?.isFetching && (attendences.length > 0 || expenses.length > 0 || periodicExpenses.length > 0)) && <div className="d-flex flex-column align-items-center justify-content-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <div className="d-block">Generating Report, it may take upto a minute...</div>
                                </div>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )
}